import { DrmType, Ovp } from "@sky-uk-ott/core-video-sdk-js";
import { detect } from "detect-browser";
import { warn } from "../../../log.js";
const DEVICE = "nbcnewsdevices";
function getDrmSchemeForBrowser(browser) {
  switch (browser == null ? void 0 : browser.name) {
    case "chrome":
    case "chromium-webview":
    case "firefox":
    case "edge-chromium":
      return DrmType.Widevine;
    case "safari":
    case "crios":
    case "fxios":
    case "ios":
    case "ios-webview":
      return DrmType.Fairplay;
    default:{
        const fallback = DrmType.Widevine;
        warn(`Could not find a DRM scheme. Falling back to ${fallback}. Browser:`, browser);
        return fallback;
      }
  }
}
function drmTypeToOvpType(drmType) {
  switch (drmType) {
    case DrmType.Fairplay:
      return Ovp.DrmType.Fairplay;
    case DrmType.Widevine:
      return Ovp.DrmType.Widevine;
    case DrmType.PlayReady:
      return Ovp.DrmType.PlayReady;
    default:
      throw new Error(`Unsupported DRM Type ${drmType}`);
  }
}
function getStreamFormatForBrowser(browser) {
  switch (browser) {
    case "chrome":
    case "chromium-webview":
    case "firefox":
    case "edge-chromium":
      return "dash";
    case "safari":
    case "crios":
    case "fxios":
    case "ios":
    case "ios-webview":
      return "hlsCBCS";
    default:
      warn(`Could not find a stream format for browser ${browser}`);
      return "dash";
  }
}
function getStreamFormat() {
  const browser = detect();
  return getStreamFormatForBrowser((browser == null ? void 0 : browser.type) === "browser" ? browser.name : void 0);
}
const formatLicenseAcquisitionUrl = ({ timestamp, token, drmType, keyId }) => {
  const url = new URL(
    `https://drmproxy.digitalsvc.apps.nbcuni.com/drm-proxy/license/${drmType.toLowerCase()}`
  );
  url.searchParams.append("time", String(timestamp));
  url.searchParams.append("hash", token);
  url.searchParams.append("device", DEVICE);
  if (keyId) {
    url.searchParams.append("keyId", keyId);
  }
  return url.toString();
};
async function getDrmConfig({ requestSigner, keyId }) {
  const browser = detect(window.navigator.userAgent);
  const drmType = getDrmSchemeForBrowser((browser == null ? void 0 : browser.type) === "browser" ? browser : void 0);
  const timestamp = Date.now();
  const token = await requestSigner(timestamp, drmType.toLowerCase());
  const result = {
    type: drmType,
    ovpType: drmTypeToOvpType(drmType),
    licenceAcquisitionUrl: formatLicenseAcquisitionUrl({ timestamp, token, drmType, keyId })
  };
  if (drmType === DrmType.Fairplay) {
    result.certificateUrl = "https://fp-keyos-nbcu.licensekeyserver.com/cert/2b947879444b6f5b798514c48927a448.der";
  }
  return result;
}
export {
  formatLicenseAcquisitionUrl,
  getDrmConfig,
  getStreamFormat };
//# sourceMappingURL=dist/components/CoreVideoPlayer/generateSessionConfig/browserConfig.js.map